<template>
    <div ref="container">
      <a-modal :title="title" :width="600" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="模板名称" prop="templateName">
                  <a-input placeholder="模板名称" v-model="form.templateName" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="remark">
                  <a-input placeholder="备注" v-model="form.remark" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-spin>
      </a-modal>
    </div>
  </template>
  <script>
  import pick from 'lodash.pick'
  import { updateTemplate, printgetAll } from '@/api/api'
  import { autoJumpNextInput } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
    },
    data() {
      return {
        title: '操作',
        visible: false,
        fileList: [],
        model: {},
        isReadOnly: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        confirmLoading: false,
        form: {
            templateName: '',
            remark: '',
        },
        uploadHeaders: {},
        action: window._CONFIG['domianURL'] + '/systemConfig/upload',
        rules: {
            templateName: [{ required: true, message: '模板名称不可为空!' }]
        },
        id: '',
      }
    },
    created() {},
    methods: {
        getlist() {
            debugger
            const res = printgetAll()
            if (res.code == 200) {
                // this.form = res.data
            } else {
                // this.$message.error(res.data || res.msg)
            }
        },
      add() {
        this.edit({})
      },
      edit(record) {
        if (this.$refs.form !== undefined) this.$refs.form.resetFields()
        this.form = Object.assign({}, record)
        this.visible = true
        this.$nextTick(() => {})
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      async handleOk() {
        const that = this
        // 触发表单验证
        let params = {
            templateId : this.form.uuid,
            templateName : this.form.templateName,
            remark : this.form.remark,
        }
        const res = await updateTemplate(params)
        console.log(res, 'res')
        if (res.code == 200) {
            this.$message.success('修改成功')
            this.close()
        } else {
            this.$message.error("修改失败")
        }
      },
      handleCancel() {
        this.close()
      },
    },
  }
  </script>
  <style scoped>
  </style>